import Enum from "../../../enums/Enum";

const DirectBillingReferralTypeEnum = new Enum({
    EXTERNAL: {name: "External"},
    INTERNAL: {name: "Internal"}
});

export default DirectBillingReferralTypeEnum;